/**
 * Survey questions come from the API with a snake_case `question_type`. The shared
 * quiz play UI (`QuizItemList` / `Question`) switches on the game's Title Case
 * vocabulary, so we normalize survey types into that vocabulary at the point the
 * `SurveyPlay` model is built. The original snake_case value is kept separately on
 * `SurveyPlayQuestion.survey_type` because the submit payload requires it.
 */
export type SurveyType =
  | 'single_choice'
  | 'multiple_choice'
  | 'open_text'
  | 'range_response'
  | 'true_false'

export type PlayQuestionType =
  | 'Multiple Choice'
  | 'Multiple Response'
  | 'True or False'
  | 'Open Text'
  | 'Scale'

export const surveyTypeToGameType = (surveyType?: SurveyType | string): PlayQuestionType => {
  switch (surveyType) {
    case 'multiple_choice':
      return 'Multiple Response'
    case 'true_false':
      return 'True or False'
    case 'open_text':
      return 'Open Text'
    case 'range_response':
      return 'Scale'
    case 'single_choice':
    default:
      return 'Multiple Choice'
  }
}
